import type { IAddress } from '@/common/interfaces/order.interface';
import { MostRecentActivityStatus } from '@/modules/MostRecent/MostRecentActivity';

export const ORDER_DETAIL_PAGE_VIEW_VALUES = {
  DEFAULT: 'default',
  PARTICIPANT: 'participant',
} as const;

export type OrderDetailPageView =
  (typeof ORDER_DETAIL_PAGE_VIEW_VALUES)[keyof typeof ORDER_DETAIL_PAGE_VIEW_VALUES];

export const ORDER_DETAIL_PAGE_VIEW_OPTIONS: {
  label: string;
  value: OrderDetailPageView;
}[] = [
  {
    label: 'Default View',
    value: ORDER_DETAIL_PAGE_VIEW_VALUES.DEFAULT,
  },
  {
    label: 'Participant View',
    value: ORDER_DETAIL_PAGE_VIEW_VALUES.PARTICIPANT,
  },
];

export const ORDER_DETAIL_PAGE_VIEW_TOGGLE_LABEL = 'Page View';

/** Status banner copy for participant Not Tipped preview. */
export const PARTICIPANT_NOT_TIPPED_STATUS_MESSAGE =
  "Your store hasn't reached the minimum yet. Keep sharing the link so more people can order.";

/** Status banner copy when a participant order failed to meet the store minimum. */
export const PARTICIPANT_FAILED_ORDER_STATUS_MESSAGE =
  'The minimum order requirement wasn’t met, so your order couldn’t be completed.';

/** Replaces invoice line-item breakdown in participant Not Tipped preview. */
export const PARTICIPANT_NOT_TIPPED_CHARGE_MESSAGE =
  "We'll charge you when the store tips — we only charge once the minimum order quantity is reached.";

/** Static order status shown in HQ Most Recent participant view preview. */
export const HQ_PARTICIPANT_MOST_RECENT_STATIC_ORDER_STATUS = MostRecentActivityStatus.inStudio;

/** Fallback shipping address for HQ participant view when order has no address on file. */
export const HQ_PARTICIPANT_PREVIEW_SHIPPING_ADDRESS: IAddress = {
  shippingName: 'Jordan Mitchell',
  street1: '1842 W Campus Drive',
  street2: 'Apt 3B',
  city: 'Ann Arbor',
  state: 'MI',
  zipCode: '48104',
};

/** Orders section title in HQ participant view preview. */
export const HQ_PARTICIPANT_ORDERS_SECTION_TITLE = 'My Orders';

/** Order card status label aligned with Most Recent participant preview. */
export const HQ_PARTICIPANT_ORDER_PREVIEW_STATUS_LABEL = 'In Studio';
